import { Component, Output, EventEmitter, OnInit, Input, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Service } from './ctl-tms-ambar-raf-arama.service';
import { DxButtonModule } from 'devextreme-angular';
import { ColumnModel } from '../../../../models/dx-data-table.model';
import { DkDxDataCtlTableComponent } from '../../../dk-dx-data-ctl-table/dk-dx-data-ctl-tablecomponent';
import { Observable } from 'rxjs';
import { TmsAmbarRafService } from '../ctl-tms-ambar-raf.service';
import { OrtakService } from '../../../../services/ortak.service';
import { CommonModule } from '@angular/common';
import {DlistDto} from "@dabnet-kamu/libs/ui";

@Component({
  selector: 'dk-ctl-tms-ambar-raf-arama',
  standalone: true,
  imports: [DkDxDataCtlTableComponent, DxButtonModule,CommonModule],
  providers: [Service],
  templateUrl: './ctl-tms-ambar-raf-arama.component.html',
  styleUrls: ['./ctl-tms-ambar-raf-arama.component.scss'],
})
export class CtlTmsAmbarRafAramaComponent implements OnInit   {
  private destroyRef = inject(DestroyRef);
  public data: any;
  public columns: ColumnModel[];
  public selectedData: any = null;
  gridControlsList$: Observable<DlistDto>;
  @Input() control: any;
  @Output() private closePopup = new EventEmitter<string>();
  constructor(
    private service: Service,
    private tmsAmbarRafService:TmsAmbarRafService,
    public ortakService:OrtakService
  ) {

  }

  ngOnInit(): void {
    this.data = this.service.getData(this.control);
    this.gridControlsList$ = this.tmsAmbarRafService.gridControlsList$;
    this.tmsAmbarRafService.gridControlsList$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(x=>{
      this.columns = this.ortakService.setRecursiveFieldData([x],false);
      })

  }

  focusChanged(e: any) {
    this.selectedData = e.row;
  }

  
  onKeyDown(e: any) {
  if (e.event?.key === 'Enter') {
      this.closePopup.emit(this.selectedData);
    }
  }
  
  dblClickRow(e:any){
    this.closePopup.emit(e);
  }

  chooseBtnClick() {
    this.closePopup.emit(this.selectedData);
  }

  cancelBtnClick() {
    this.closePopup.emit(null);
  }
}

